<template>
    <vx-modal v-model:visible="visible" size="lg" padding="standard">
        <template v-slot:header> Terms Acceptances </template>
        <template v-slot:subheader>
            {{ props.term?.title }}
        </template>

        <term-acceptances v-if="visible && props.term" :teamId="props.teamId" :term="props.term" />
    </vx-modal>
</template>

<script lang="ts" setup>
import { VxModal } from '@voxie/frontend-components';
import type { Term } from '~/services/adminTermsClient.types';
import TermAcceptances from './TermAcceptances.vue';

const props = defineProps<{
    teamId: number;
    term: Term | null;
}>();

const visible = defineModel<boolean>('visible', { default: false });
</script>
